import { ApiServiceWithSettings, Audience, Authentication } from '../../common'
import { AxiosPromise } from 'axios'
import qs from 'qs'
import { Pagination, Tasks } from '@one/types'

export class AppTasksApi extends ApiServiceWithSettings {
  getFormByCategoryId(
    categoryId: number
  ): AxiosPromise<Tasks.Tasks.ShopFormTemplateDto> {
    return this.get(`/shop-form/${categoryId}`, {
      authentication: Authentication.OPTIONAL,
      aud: Audience.APP
    })
  }

  submitForm(
    filledShopForm: Tasks.Tasks.FilledShopFormDto,
    recaptchaToken?: string
  ): AxiosPromise<Tasks.Tasks.ShopFormResponseDto> {
    return this.post(
      '/shop-form/submit',
      {
        categoryId: filledShopForm.categoryId,
        content: filledShopForm.content
      },
      {
        authentication: Authentication.OPTIONAL,
        aud: Audience.APP,
        ...(recaptchaToken && {
          headers: {
            'X-Recaptcha-Response': recaptchaToken
          }
        })
      }
    )
  }

  getUploadFinished(
    filledShopForm: Tasks.Tasks.UploadQuery
  ): AxiosPromise<Tasks.Tasks.UploadFinishedSuccess> {
    return this.get(`/upload-finished`, {
      authentication: Authentication.PUBLIC,
      aud: Audience.APP,
      params: filledShopForm,
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    })
  }

  submitUploadFinished(
    filledShopForm: Tasks.Tasks.UploadQuery
  ): AxiosPromise<Tasks.Tasks.UploadFinishedSuccess> {
    return this.post('/upload-finished', filledShopForm, {
      authentication: Authentication.PUBLIC,
      aud: Audience.APP
    })
  }
}
